export const validateBusinessName = (value) => {
  // Allow letters, spaces, ampersand, 2-100 chars
  const regex = /^[a-zA-Z\s&]{2,100}$/;
  return regex.test(value);
};

export const validateName = (text) => {
  // Only allow letters and spaces, 2-50 chars
  const regex = /^[a-zA-Z\s]{2,255}$/;
  return regex.test(text);
};

export const validateText = (value) => {
  // Only allow letters and spaces
  const regex = /^[a-zA-Z\s]+$/;
  return regex.test(value);
};

export const EmailValidation = (text) => {
  // Strict email validation that prevents SQL injection and malicious patterns
  const sqlInjectionPattern = /(\b(SELECT|INSERT|UPDATE|DELETE|DROP|UNION|ALTER|EXEC|DECLARE)\b)|(--)|(;)|(\/\*)|(\*\/)|(\b(OR|AND)\b\s+\d+\s*=\s*\d+)|(\b(OR|AND)\b\s*['"]\s*\d+\s*=\s*\d+\s*['"])/i;
  const maliciousPattern = /<script.*?>.*?<\/script>|[<>\\{}="'"]|https?:\/\/\S+/i;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(text) && !sqlInjectionPattern.test(text) && !maliciousPattern.test(text);
};

export const PasswordValidation = (text) => {
  // Exclude <, >, {, }, ", ', | for safety
  const sqlInjectionPattern = /(\b(SELECT|INSERT|UPDATE|DELETE|DROP|UNION|ALTER|EXEC|DECLARE)\b)|(--)|(;)|(\/\*)|(\*\/)|(\b(OR|AND)\b\s+\d+\s*=\s*\d+)|(\b(OR|AND)\b\s*['"]\s*\d+\s*=\s*\d+\s*['"])/i;
  const maliciousPattern = /<script.*?>.*?<\/script>|[<>\\{}="'"]|https?:\/\/\S+/i;
  const passwordRegex = /^[a-zA-Z0-9@#$%^&*()_+\-=\[\];:,.?/]{8,16}$/;
  return passwordRegex.test(text) && !sqlInjectionPattern.test(text) && !maliciousPattern.test(text);
};

export const MobileTenDigitValidation = (text) => {
  // Only numbers allowed, exactly 10 digits
  const regex = /^[0-9]{10}$/;
  return regex.test(text);
};

export const AddressValidation = (text) => {
  // Allow only safe characters for address
  const regex = /^[a-zA-Z0-9\s.,/-]+$/;
  return regex.test(text);
};

export const Pincode = (text) => {
  // Only numbers allowed, exactly 6 digits
  const regex = /^[0-9]{6}$/;
  return regex.test(text);
};

export const removeSpaces = (string) => {
  return string.replace(/\s+/g, "");
};

export const sanitizeInput = (value) => {
  if (typeof value !== 'string') return '';

  // Remove script tags
  let sanitized = value.replace(/<\s*script\b[^>]*>(.*?)<\s*\/\s*script\s*>/gi, '');

  // Remove URLs
  sanitized = sanitized.replace(/\b(?:https?:\/\/|ftp:\/\/|www\.)\S+/gi, '');

  // Remove SQL keywords
  sanitized = sanitized.replace(/\b(SELECT|INSERT|UPDATE|DELETE|DROP|UNION|ALTER|CREATE)\b/gi, '');

  // Remove special characters
  sanitized = sanitized.replace(/[!@#$%^&*()~`<>={}[\]\\'"`;:/]/g, '');

  return sanitized;
};

